import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import { RiDeleteBin6Line } from "react-icons/ri";

const KeywordCategoryTable = ({ categories, onCategorySelect, handleDeleteCategory }) => {
    const allCategories = [{ _id: "all", categoryName: "All Keywords" }, ...categories];

    const columns = [
        {
            field: "name",
            headerName: "Category Name",
            flex: 3,
        },
        {
            field: "actions",
            headerName: "",
            flex: 1,
            renderCell: (params) => (
                <IconButton
                    onClick={() => handleDeleteCategory(params.id)}
                    sx={{ cursor: "pointer", color: "error.main", fontSize: "1.3rem" }}
                >
                    <RiDeleteBin6Line />
                </IconButton>
            ),
        },
    ];

    const rows = allCategories.map((item) => ({
        id: item._id,
        name: item.categoryName,
    }));

    return (
        <div
            style={{
                height: "370px",
                width: "100%",
                overflow: "hidden",
                border: "none",
            }}
        >
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooter
                onRowClick={(params) => onCategorySelect(params.id)}
                sx={{
                    fontFamily: "Poppins, sans-serif",
                    "& .MuiDataGrid-columnHeaders": {
                        color: "white",
                        fontSize: "1.25rem",
                        borderBottom: "solid",
                    },
                    "& .MuiDataGrid-row": {
                        backgroundColor:
                            "linear-gradient(to right, #000000, #06041f, #0d0d55, #15178e)",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#2D3748",
                        },
                        "&.Mui-selected": {
                            backgroundColor: "#4A5568 !important",
                        },
                    },
                }}
            />
        </div>
    );
};

export default KeywordCategoryTable;
